import { render } from "./LoadingIndicator.vue?vue&type=template&id=3567be4e&scoped=true&ts=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=3567be4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3567be4e"]])

export default __exports__